import { PluginKey, Plugin } from 'prosemirror-state';
import { CommonExtension } from '../../../core/index.js';
import 'prosemirror-inputrules';
import { Slice, Fragment } from 'prosemirror-model';
import 'prosemirror-commands';

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var AFTER_INSERT = "after_insert";

var hasExtensionProperty = function(key) {
    return function(extension) {
        return Boolean(extension[key]);
    };
};
var SHADOWDOM_CLASS = "ct-web-dangers-shadow-wrapper";

var isCopyFromExcel = function(html) {
    return html.includes('xmlns:o="urn:schemas-microsoft-com:office:office"') && html.includes('xmlns:x="urn:schemas-microsoft-com:office:excel"');
};
// 由 Excel/WPS 复制
var parseExcel = function(html) {
    if (isCopyFromExcel(html)) {
        return html.replace(/(<\/html>)[\s\S]*$/, "$1").replace(/<br>\s*/g, "<br>​"); // 零宽度字符替换br后多余空白符
    }
    return html;
};
// 由学城浏览态复制 todo: 浏览态换成编辑器后可以去掉
var parseCitadelView = function(html) {
    // drawio 浏览态存在 shadowDOM
    if (~html.indexOf(SHADOWDOM_CLASS)) {
        var createSpan = document.createElement("span");
        createSpan.innerHTML = html;
        createSpan.querySelectorAll(".".concat(SHADOWDOM_CLASS)).forEach(function(el) {
            return el.remove();
        });
        html = createSpan.innerHTML;
    }
    return html.replace(/(<a[^>]*?[^-])color:[^>]*?;([^<]*?<\/a>)/g, "$1$2") // 移除链接颜色
    .replace(/color: rgb\(51, 51, 51\);/g, "") // 移除默认颜色
    .replace(/(<td[^>]*?)background-color: rgb\(255, 255, 255\);([^<]*?<\/td>)/g, "$1$2") // 处理空白背景单元格
    .replace(/(<td[^<]*?>)(\s*?)(<\/td>)/g, "$1<p></p>$3") // 处理空单元格
    .replace(/(<li[^<]*?>)(\s*?)(<\/li>)/g, "$1<p></p>$3") // 处理空序列
    // .replace(/<tr[^>]*?cloneHeader.*?<\/tr>/g, "") // 浏览态克隆的表头行
    .replace(/(<div class="ct-gantt.*?>).*?(<\/div>)/g, "$1$2") // 去除甘特图内容
    .replace(/(<td[^>]*?>[^<]*?)(<!--EndFragment-->)/g, "$1<p></p></td></tr></tbody></table></div>$2") // 修复浏览态复制表格HTML结构不全
    .replace(/&amp;isNewContent=\w*/g, ""); // 去除浏览态复制来的isNewContent信息
};
var otherFilter = function(html) {
    return html.replace(/<img[^>]*? src="file:\/\/\/[^<]*?>/g, "") // 过滤掉未上传成功的图片
    .replace(/<img[^>]*? src="https:\/\/file\.sankuai\.com\/pan\/[^<]*?>/g, "<span>​</span>") // 移除大象图片
    .replace(/ct-selected/g, ""); // 移除选中状态
};
var handlePMSlice = function(html) {
    var codeTestReg = /class="ct-code"[^>]*?data-pm-slice="/;
    var pageTreeTestReg = /class="ct-page-tree"[^>]*?data-pm-slice="/;
    var ganttTestReg = /class="ct-gantt"[^>]*?data-pm-slice="/;
    var htmlTestReg = /class="ct-html"[\s\S]*data-pm-slice="/;
    var markdownTestReg = /class="ct-markdown"[^>]*?data-pm-slice="/;
    var latexTestReg = /class="ct-latex"[^>]*?data-pm-slice="/;
    var spaceUpdateReg = /class="ct-space-update"[^>]*?data-pm-slice="/;
    var timeReg = /time[^>]*?data-pm-slice="/;
    var removePMSlice = true;
    if (html.includes('data-pm-slice="')) {
        if (!html.includes('data-pm-slice="none"')) {
            if (codeTestReg.test(html) || pageTreeTestReg.test(html) || ganttTestReg.test(html) || htmlTestReg.test(html) || markdownTestReg.test(html) || latexTestReg.test(html) || spaceUpdateReg.test(html) || timeReg.test(html)) {
                removePMSlice = false;
            }
        }
    }
    if (removePMSlice) html = html.replace(/ data-pm-slice="[^>]*?"/g, "");
    return html;
};
var transformPastedHTML = function(html, pasteRule, extensions) {
    if (pasteRule) html = pasteRule(html);
    html = parseExcel(html);
    html = parseCitadelView(html);
    html = otherFilter(html);
    extensions.filter(hasExtensionProperty("transformPastedHTML")).forEach(function(extension) {
        html = extension.transformPastedHTML(html);
    });
    html = handlePMSlice(html);
    return html;
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// 撑开外层元素（表格）的宽度
var handleBraceWidth = function(node, eventEmitter) {
    if (node.type.spec.braceWidth) {
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit(AFTER_INSERT, {
            braceWidth: node.type.spec.braceWidth
        });
    }
};
var adjustSliceOpenStart = function(slice) {
    // 找到第一个离 openStart 最近的 Block 父节点所在的层级，设置成新的 openSlice
    // 试图解决 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/21232816
    // TODO(铁峰)：需要明确部分宏复制粘贴交互的正确性定义，包括但不限于列表，展开
    var content = slice.content;
    var nOpenStart = slice.openStart;
    for(var i = 1; i <= slice.openStart; i++){
        var node = content.firstChild;
        if (node.isBlock) {
            nOpenStart = i;
        }
        content = node.content;
    }
    slice.openStart = nOpenStart;
};
var transformPasted = function(slice, state, schema, extensions, eventEmitter) {
    adjustSliceOpenStart(slice);
    var handleNode = function(node, parentNode) {
        if (node && node.type.name === "text") {
            node.text = node.text.normalize();
        }
        var newNode = node;
        handleBraceWidth(node, eventEmitter);
        extensions.filter(hasExtensionProperty("transformPasted")).forEach(function(extension) {
            if (Array.isArray(newNode)) {
                newNode = newNode.reduce(function(nodes, curNode) {
                    var ret = extension.transformPasted(state, curNode, parentNode);
                    return Array.isArray(ret) ? _toConsumableArray(nodes).concat(_toConsumableArray(ret)) : _toConsumableArray(nodes).concat([
                        ret
                    ]);
                }, []);
            } else {
                newNode = extension.transformPasted(state, newNode, parentNode);
            }
        });
        return Array.isArray(newNode) ? newNode : [
            newNode
        ];
    };
    // 递归遍历所有 Node
    // 约定 1：子节点放入第一个节点内
    // 约定 2：transformPasted 过程中生成的 node.content 会被忽略
    var traverseNode = function(frag, parentNode) {
        var allNewNodes = [];
        frag.forEach(function(node) {
            var _allNewNodes;
            // 先处理子节点(content)，再处理当前节点(copied)
            var content = node.content;
            var newContent = Fragment.empty;
            if (content && content.size > 0) {
                newContent = traverseNode(content, node);
            }
            // textNode copy 时必须传入 content
            var copied = node.type === schema.nodes.text ? node : node.copy();
            // 支持一个 node 在处理后变为多个 node（在 link-extension 中使用到这个特性）
            var newNodes = handleNode(copied, parentNode);
            if (newContent && newContent.size > 0 && (newNodes === null || newNodes === void 0 ? void 0 : newNodes.length)) {
                if (newNodes[0].type.validContent(newContent)) {
                    newNodes[0].content = newContent;
                } else {
                    newNodes[0].content = Fragment.from(node.content);
                }
            }
            (_allNewNodes = allNewNodes).push.apply(_allNewNodes, _toConsumableArray(newNodes));
        });
        return Fragment.fromArray(allNewNodes);
    };
    slice = new Slice(traverseNode(slice.content), slice.openStart, slice.openEnd);
    return slice;
};

var handlePaste = function(view, event, slice, extensions) {
    var hasHandled = false;
    extensions.filter(hasExtensionProperty("handlePaste")).forEach(function(extension) {
        if (!hasHandled) {
            hasHandled = extension.handlePaste({
                view: view,
                event: event,
                slice: slice
            });
        }
    });
    return hasHandled;
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var PasteExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(PasteExtension, CommonExtension);
    var _super = _createSuper(PasteExtension);
    function PasteExtension() {
        _classCallCheck(this, PasteExtension);
        return _super.apply(this, arguments);
    }
    var _proto = PasteExtension.prototype;
    _proto.plugin = function plugin(param) {
        var schema = param.schema, getState = param.getState, editorEventEmitter = param.editorEventEmitter;
        var _this_options = this.options, pasteRule = _this_options.pasteRule, extensions = _this_options.extensions;
        return new Plugin({
            key: new PluginKey("paste"),
            props: {
                // 剪切板内字符串级别转换
                transformPastedHTML: function(html) {
                    return transformPastedHTML(html, pasteRule, extensions);
                },
                // 内容已经转换为ProseMirror模型后处理
                transformPasted: function(slice) {
                    return transformPasted(slice, getState(), schema, extensions, editorEventEmitter);
                },
                // 已经进入到事件hook中的paste处理
                handlePaste: function(view, event, slice) {
                    return handlePaste(view, event, slice, extensions);
                }
            }
        });
    };
    _createClass(PasteExtension, [
        {
            key: "name",
            get: function get() {
                return "paste";
            }
        }
    ]);
    return PasteExtension;
}(CommonExtension);

export { PasteExtension };
//# sourceMappingURL=index.js.map
